import React, { useState } from 'react';
import { useModalStore } from '../../../common/hooks/useModals';
import AddAccountUserModalStepOne, { AddAccountUserModalStepOneModel } from './AddAccountUserModalStepOne';
import AddAccountUserModalStepTwo from './AddAccountUserModalStepTwo';
import AddAccountUserModalStepThreeFleet from './AddAccountUserModalStepThreeFleet';
import AddAccountUserModalStepThreeAircraft from './AddAccountUserModalStepThreeAircraft';

type FormStep = typeof FormSteps[keyof typeof FormSteps];
const FormSteps = {
  UserInfoAndRole: 1,
  AccessMethod: 2,
  FleetSelection: 3,
  AircraftSelection: 4,
} as const;

type AddAccountUserModalStore = {
    addAccountUser: {companyId: number; refreshUserList: () => void;};
    setAddAccountUserState: (state: boolean) => void;
};
function Model(): React.JSX.Element {
  const { addAccountUser, setAddAccountUserState } = useModalStore() as AddAccountUserModalStore;
  const [currentStep, setCurrentStep] = useState<FormStep>(FormSteps.UserInfoAndRole);
  const [userInfo, setUserInfo] = useState<AddAccountUserModalStepOneModel>({
    firstName: '',
    lastName: '',
    email: '',
    loginNeverExpires: true,
    loginExpirationDate: null,
    role: null,
    userType: null,
  });
  const [accessMethod, setAccessMethod] = useState('');

  const handleClose = (): void => {
    setAddAccountUserState(false);
  };

  switch (currentStep) {
    case FormSteps.AircraftSelection:
      return (
        <AddAccountUserModalStepThreeAircraft
          handleClose={handleClose}
          goToPreviousStep={() => setCurrentStep(FormSteps.AccessMethod)}
          userInfo={userInfo}
          companyId={addAccountUser.companyId}
          refreshUserList={addAccountUser.refreshUserList}
        />
      );
    case FormSteps.FleetSelection:
      return (
        <AddAccountUserModalStepThreeFleet
          handleClose={handleClose}
          goToPreviousStep={() => setCurrentStep(FormSteps.AccessMethod)}
          userInfo={userInfo}
          companyId={addAccountUser.companyId}
          refreshUserList={addAccountUser.refreshUserList}
        />
      );
    case FormSteps.AccessMethod:
      return (
        <AddAccountUserModalStepTwo
          handleClose={handleClose}
          goToNextStep={(method) => {
            setAccessMethod(method);

            setCurrentStep(method === 'Fleet' ? FormSteps.FleetSelection : FormSteps.AircraftSelection);
          }}
          goToPreviousStep={() => setCurrentStep(FormSteps.UserInfoAndRole)}
          method={accessMethod}
          firstName={userInfo.firstName}
          lastName={userInfo.lastName}
        />
      );
    case FormSteps.UserInfoAndRole:
    default:
      return (
        <AddAccountUserModalStepOne
          handleClose={handleClose}
          goToNextStep={(model) => {
            setUserInfo(model);
            setCurrentStep(FormSteps.AccessMethod);
          }}
          model={userInfo}
          companyId={addAccountUser.companyId}
          refreshUserList={addAccountUser.refreshUserList}
        />
      );
  }
}

export default Model;
